module.exports = __webpack_public_path__ + "img/IMG_9321_L_BlackMatted_MockedUp.aeaf19f1.jpg";